export default __webpack_public_path__ + "static/media/CardCityHall.4d229c60.jpg";